<template>
  <div class="setHwInfo">
    <el-form>
      <el-form-item>
        <el-table :data="hwInfoData"
                  @select="handleSelect" @select-all="handleSelectAll" :cell-style="{textAlign: 'center'}"
                  :header-cell-style="{textAlign: 'center', background: '#E5E7E9'}">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            v-for="{ prop, label } in colConfigs"
            :key="prop"
            :prop="prop"
            :label="label">
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item>
        <el-button type="success" plain @click="onSubmit">Confirm</el-button>
        <el-button type="info" plain @click="$router.go(-1)">Cancel</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'SetHwInfo',
  data () {
    this.colConfigs = [
      { prop: 'desc', label: 'Description' },
      { prop: 'id', label: 'ID' }
    ]
    return {
      hwInfoData: [],
      er_num: null
    }
  },
  created: function () {
    console.log('SetHwInfo - created')
    this.hwInfoData = this.$route.params.data
    this.er_num = this.$route.params.er_num

    console.log('er_num')
    console.log(this.er_num)
  },
  methods: {
    onSubmit () {
      console.log('Router to GenLocalLicense')
      this.$router.push({name: 'GenLocalLicense', params: { data: this.hwInfoData, er_num: this.er_num }})
    },
    handleSelect (selection, row) {
      let selected = selection.length && selection.indexOf(row) !== -1
      console.log(selected)
      row.enable = selected === true ? 1 : 0
    },
    handleSelectAll (selection) {
      let enable = selection.length !== 0
      if (this.hwInfoData) {
        for (let i = 0; i < this.hwInfoData.length; i++) {
          this.hwInfoData[i].enable = enable === true ? 1 : 0
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.welcome{
  margin: 0px auto;
  max-width: 350px;
  position: relative;
  margin-top: 50px;
}
</style>

<style>
.el-table .cell {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// SetHwInfo.vue?7bc7af87